(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('legendaIndicador', LegendaIndicador);

  function LegendaIndicador() {
    return {
      restrict: 'E',
      scope: {
        dados: '='
      },
      templateUrl: 'views/directives/legenda_indicadores.html',
      link(scope) {
        const indicadores = scope.dados.indicadores;

        scope.showLegenda = indicadores.filter(function(indicador) {
          return indicador.indicador.tipo ==='valor' || indicador.indicador.tipo ==='percentual';
        });
      }
    };
  }
}());
